/*
 * @Author: your name
 * @Date: 2022-01-09 17:45:53
 * @LastEditTime: 2022-03-03 12:04:42
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\utils\storage-service.js
 */

/**
 * 储存工具
 * 支持两种模式（全局挂载安装 & 直接引用）
 */

import { WebStorageEvent } from './storage-event';
export class storageServiceProvider {

    /**
     * 使用localStorage（本地缓存）作为存储数据库
     */
    constructor() {
        this.storage = localStorage;
        this.options = {
          namespace: '',
        };
    }    
    
    /**
     * 获取缓存信息
     *
     * @param {string} key
     * @param {*} def - default value
     * @returns {*}
    */
    get(key, def = null) {
        const item = this.storage.getItem(this.options.namespace + key);

        if (item !== null) {
            try {
                const data = JSON.parse(item);

                if (data.expire === null) {
                    return data.value;
                }

                if (data.expire >= new Date().getTime()) {
                    return data.value;
                }
                
                this.remove(key);
            } catch (err) {
                return def;
            }
        }
        return def;
    }

    /** 
     * 设置缓存信息
     * @param key  缓存的key
     * @param value 缓存的值
     * */
    set(key, value, expire = null) {
        const stringifyValue = JSON.stringify({
          value,
          expire: expire !== null ? new Date().getTime() + expire : null,
        });
    
        this.storage.setItem(this.options.namespace + key, stringifyValue);
    }

    /**
     * 移除缓存信息
     * @param key  缓存的key
     */
    remove(key) {
        return this.storage.removeItem(this.options.namespace + key);
    }

    /**
     * 清除缓存信息（所有）
     */
    clear() {
        if (this.storage.length === 0) {
            return;
        }
        const removedKeys = [];
    
        for (let i = 0; i < this.storage.length; i++) {
            const key = this.storage.key(i);
            const regexp = new RegExp(`^${this.options.namespace}.+`, 'i');
    
            if (regexp.test(key) === false) {
            continue;
            }
    
            removedKeys.push(key);
        }
    
        for (const key in removedKeys) {
            this.storage.removeItem(removedKeys[key]);
        }
    }


    /**
     * Add storage change event
     *
     * @param {string} name
     * @param {Function} callback
     */
    on(name, callback) {
        WebStorageEvent.on(this.options.namespace + name, callback);
    }

    /**
     * Remove storage change event
     *
     * @param {string} name
     * @param {Function} callback
     */
    off(name, callback) {
        WebStorageEvent.off(this.options.namespace + name, callback);
    }
}
export default new storageServiceProvider()